// 区号选择器组件 JavaScript
// 使用 libphonenumber-js 库

// 所有国家列表 - 使用 libphonenumber-js 库获取
let ALL_COUNTRIES = [];

function ensureDropdownCoordinator() {
  if (window.StruttDropdownCoordinator) {
    return window.StruttDropdownCoordinator;
  }

  function isSameDropdown(node, activeNode) {
    if (!node || !activeNode) return false;
    return node === activeNode || node.contains(activeNode) || activeNode.contains(node);
  }

  window.StruttDropdownCoordinator = {
    closeOthers(activeNode) {
      document.querySelectorAll('.component-country-selector.expanded').forEach(selector => {
        if (isSameDropdown(selector, activeNode)) return;
        selector.classList.remove('expanded');
        selector.style.setProperty('--component-country-selector-expanded-space', '0px');
        const rootContent = selector.closest('.root-content');
        if (selector.closest('.fill-information-page') && rootContent) {
          rootContent.style.setProperty('--root-content-country-selector-expanded-space', '0px');
        }
      });

      document.querySelectorAll('.component-input-selector--input.expanded').forEach(selector => {
        if (isSameDropdown(selector, activeNode)) return;
        selector.classList.remove('expanded');
        selector.classList.remove('is-focused');
      });

      document.querySelectorAll('.component-filter__state-layer[aria-expanded="true"]').forEach(toggle => {
        if (isSameDropdown(toggle, activeNode)) return;
        toggle.setAttribute('aria-expanded', 'false');
        const wrapper = toggle.closest('.component-filter__wrapper');
        const group = wrapper ? wrapper.closest('.component-filter__group') : null;
        const dropdown = group ? group.querySelector('.component-filter__dropdown') : null;
        if (dropdown) dropdown.setAttribute('hidden', '');
      });

      document.querySelectorAll('[data-component="dialcode-selector"]').forEach(selector => {
        if (isSameDropdown(selector, activeNode)) return;
        const instance = window.DialCodeSelector && typeof window.DialCodeSelector.getInstance === 'function'
          ? window.DialCodeSelector.getInstance(selector)
          : null;
        if (instance && instance.isDropdownOpen) {
          instance.closeDropdown();
        }
      });
    }
  };

  return window.StruttDropdownCoordinator;
}


function getCountryDisplayLocale() {
  const rawLocale = String(
    (window.Shopify && window.Shopify.locale) ||
    (document.documentElement && document.documentElement.lang) ||
    'en'
  ).trim();
  const lowerLocale = rawLocale.toLowerCase();

  if (lowerLocale === 'zh-cn') return 'zh-CN';
  if (lowerLocale === 'zh-tw') return 'zh-TW';
  if (lowerLocale.startsWith('zh')) return lowerLocale.includes('tw') ? 'zh-TW' : 'zh-CN';
  if (lowerLocale.startsWith('de')) return 'de';
  if (lowerLocale.startsWith('fr')) return 'fr';
  if (lowerLocale.startsWith('it')) return 'it';
  if (lowerLocale.startsWith('nl')) return 'nl';
  if (lowerLocale.startsWith('es')) return 'es';
  if (lowerLocale.startsWith('ja')) return 'ja';
  if (lowerLocale.startsWith('ko')) return 'ko';
  if (lowerLocale.startsWith('th')) return 'th';
  return 'en';
}

function getDialcodeSelectorMessages() {
  const rawLocale = String(
    (window.Shopify && window.Shopify.locale) ||
    (document.documentElement && document.documentElement.lang) ||
    'en'
  ).trim().toLowerCase();
  const localeBase = rawLocale.split('-')[0];
  const messagesByLocale = {
    'zh-cn': {
      noMatchingResults: '未找到匹配结果',
      moreOptionsBelow: '更多选项如下',
      chooseOptionFromList: '请从列表中选择一个选项'
    },
    'zh-tw': {
      noMatchingResults: '找不到相符結果',
      moreOptionsBelow: '更多選項如下',
      chooseOptionFromList: '請從清單中選擇一個選項'
    },
    de: {
      noMatchingResults: 'Keine passenden Ergebnisse gefunden.',
      moreOptionsBelow: 'Weitere Optionen unten',
      chooseOptionFromList: 'Bitte wähle eine Option aus der Liste.'
    },
    fr: {
      noMatchingResults: 'Aucun résultat correspondant trouvé.',
      moreOptionsBelow: 'Plus d’options ci-dessous',
      chooseOptionFromList: 'Veuillez choisir une option dans la liste.'
    },
    es: {
      noMatchingResults: 'No se encontraron resultados coincidentes.',
      moreOptionsBelow: 'Más opciones abajo',
      chooseOptionFromList: 'Por favor, elige una opción de la lista.'
    },
    it: {
      noMatchingResults: 'Nessun risultato corrispondente trovato.',
      moreOptionsBelow: 'Altre opzioni qui sotto',
      chooseOptionFromList: "Seleziona un'opzione dall'elenco."
    },
    nl: {
      noMatchingResults: 'Geen overeenkomende resultaten gevonden.',
      moreOptionsBelow: 'Meer opties hieronder',
      chooseOptionFromList: 'Kies een optie uit de lijst.'
    }
  };
  const fallbackMessages = {
    noMatchingResults: 'No matching results found.',
    moreOptionsBelow: 'More options below',
    chooseOptionFromList: 'Please choose an option from the list'
  };
  const globalMessages = window.frontendMessages || {};

  return Object.assign(
    {},
    fallbackMessages,
    messagesByLocale[rawLocale] || messagesByLocale[localeBase] || {},
    {
      chooseOptionFromList: globalMessages.chooseOptionFromList
        || (messagesByLocale[rawLocale] || messagesByLocale[localeBase] || {}).chooseOptionFromList
        || fallbackMessages.chooseOptionFromList
    }
  );
}

function getSpecialCountryName(countryCode, locale) {
  const normalizedLocale = getCountryDisplayLocale(locale);
  const specialNames = {
    HK: {
      en: 'Hong Kong (China)',
      'zh-CN': '中国香港',
      'zh-TW': '中國香港'
    },
    TW: {
      en: 'Taiwan (China)',
      'zh-CN': '中国台湾',
      'zh-TW': '中國台灣'
    },
    MO: {
      en: 'Macao (China)',
      'zh-CN': '中国澳门',
      'zh-TW': '中國澳門'
    }
  };

  const names = specialNames[countryCode];
  if (!names) return '';
  return names[normalizedLocale] || names.en || '';
}

// 初始化国家数据
function initializeCountries() {
  // 检查库是否可用
  if (typeof libphonenumber !== 'undefined') {
    try {
      // 使用 libphonenumber-js 库获取所有国家
      const countryCodes = libphonenumber.getCountries();
      // 过滤掉没有区号的国家
      ALL_COUNTRIES = countryCodes.filter(countryCode => {
        try {
          const dialCode = libphonenumber.getCountryCallingCode(countryCode);
          return dialCode && dialCode.length > 0;
        } catch (error) {
          return false;
        }
      });
      
      // 按国家名称字母顺序排序
      ALL_COUNTRIES.sort((a, b) => {
        const nameA = getCountryNameHelper(a).toLowerCase();
        const nameB = getCountryNameHelper(b).toLowerCase();
        return nameA.localeCompare(nameB);
      });
    } catch (error) {
      console.error('libphonenumber-js 初始化国家数据失败:', error);
      ALL_COUNTRIES = [];
    }
  } else {
    console.error('libphonenumber-js 未加载，无法初始化国家数据');
    ALL_COUNTRIES = [];
  }
}

// 获取国家名称的辅助函数
function getCountryNameHelper(countryCode) {
  if (window.CountryDisplayUtils && typeof window.CountryDisplayUtils.getLocalizedCountryName === 'function') {
    const sharedCountryName = window.CountryDisplayUtils.getLocalizedCountryName(countryCode, getCountryDisplayLocale(), '');
    if (sharedCountryName) {
      return sharedCountryName;
    }
  }

  const locale = getCountryDisplayLocale();
  const specialName = getSpecialCountryName(countryCode, locale);
  if (specialName) {
    return specialName;
  }

  // 尝试使用 Intl.DisplayNames API 获取完整的国家名称
  if (typeof Intl !== 'undefined' && Intl.DisplayNames) {
    try {
      const displayNames = new Intl.DisplayNames([locale, 'en'], { type: 'region' });
      const countryName = displayNames.of(countryCode);
      if (countryName && countryName !== countryCode) {
        return countryName;
      }
    } catch (error) {
      // 如果 Intl.DisplayNames 失败，使用备用数据
    }
  }
  
  // 备用国家名称数据
  const countryNames = {
    'US': 'United States', 'CN': 'China', 'JP': 'Japan', 'KR': 'South Korea',
    'GB': 'United Kingdom', 'DE': 'Germany', 'FR': 'France', 'CA': 'Canada',
    'AU': 'Australia', 'IN': 'India', 'BR': 'Brazil', 'RU': 'Russia',
    'IT': 'Italy', 'ES': 'Spain', 'NL': 'Netherlands', 'SE': 'Sweden',
    'NO': 'Norway', 'DK': 'Denmark', 'FI': 'Finland', 'CH': 'Switzerland',
    'AT': 'Austria', 'BE': 'Belgium', 'PL': 'Poland', 'CZ': 'Czech Republic',
    'HU': 'Hungary', 'RO': 'Romania', 'BG': 'Bulgaria', 'HR': 'Croatia',
    'SI': 'Slovenia', 'SK': 'Slovakia', 'LT': 'Lithuania', 'LV': 'Latvia',
    'EE': 'Estonia', 'IE': 'Ireland', 'PT': 'Portugal', 'GR': 'Greece',
    'TR': 'Turkey', 'IL': 'Israel', 'SA': 'Saudi Arabia', 'AE': 'United Arab Emirates',
    'EG': 'Egypt', 'ZA': 'South Africa', 'NG': 'Nigeria', 'KE': 'Kenya',
    'MX': 'Mexico', 'AR': 'Argentina', 'CL': 'Chile', 'CO': 'Colombia',
    'PE': 'Peru', 'VE': 'Venezuela', 'MY': 'Malaysia', 'SG': 'Singapore',
    'TH': 'Thailand', 'VN': 'Vietnam', 'PH': 'Philippines', 'ID': 'Indonesia',
    'NZ': 'New Zealand'
  };
  
  return countryNames[countryCode] || countryCode;
}

// 区号选择器类
class DialCodeSelector {
  constructor(container) {
    this.container = container;
    this.stateLayer = container.querySelector('.component-dialcode-selector__state-layer');
    this.dropdown = container.querySelector('.component-dialcode-selector__dropdown');
    this.list = container.querySelector('.component-dialcode-selector__list');
    this.hiddenInput = container.querySelector('input[type="hidden"]');
    this.inputText = container.querySelector('.component-dialcode-selector__input-text');
    this.messages = getDialcodeSelectorMessages();
    this.searchQuery = '';
    
    // 确保国家数据已初始化
    if (ALL_COUNTRIES.length === 0) {
      initializeCountries();
    }
    
    // 默认不选中任何国家
    this.currentCountry = null;
    this.isDropdownOpen = false;
    this.isSelected = false; // 标记是否已选择国家，默认未选择
    
    this.init();
  }
  
  init() {
    this.setupEventListeners();
    // 初始化时不显示区号，保持显示 "AREA"
    this.updateDisplay();
    this.renderCountryList();
  }
  
  setupEventListeners() {
    // 输入框事件
    if (this.inputText) {
      // 点击与聚焦时打开下拉
      this.inputText.addEventListener('click', (e) => {
        e.stopPropagation();
        // 确保输入框获得焦点
        if (document.activeElement !== this.inputText) {
          this.inputText.focus();
        }
        if (!this.isDropdownOpen) this.openDropdown();
      });
      this.inputText.addEventListener('focus', () => {
        // 聚焦时清除错误态与错误文案（切换为聚焦态）
        this.container.classList.remove('component-dialcode-selector--error');
        const errorElement = this.container.querySelector('.component-dialcode-selector__error');
        if (errorElement) {
          errorElement.style.display = 'none';
        }

        // 确保输入框获得焦点后展开下拉框
        if (!this.isDropdownOpen) {
          this.openDropdown();
        }
        const label = this.container.querySelector('.component-dialcode-selector__label');
        // 聚焦时始终显示label（与国家选择器一致）
        if (label) {
          label.classList.add('is-float');
        }
        // 如果有搜索内容，触发搜索
        if (this.searchQuery && this.searchQuery.trim()) {
          this.filterCountries();
        }
      });
      // 不限制输入字符：允许用户自由搜索（包含符号）
      this.inputText.addEventListener('blur', () => {
        const label = this.container.querySelector('.component-dialcode-selector__label');
        const inputValue = (this.inputText.value || '').trim();
        
        // 如果已经选择了区号：
        // - 输入被清空：视为用户主动清除选择，保持空值 + label 居中
        // - 其他情况：失焦时恢复显示选中的区号（与国家选择器一致）
        if (this.isSelected && this.currentCountry) {
          if (!inputValue) {
            this.searchQuery = '';
            this.currentCountry = null;
            this.isSelected = false;
            this.updateDisplay();
          } else {
            // 恢复显示选中的区号（与国家选择器一致）
            this.updateDisplay();
            // 保持label浮动状态
            if (label) {
              label.classList.add('is-float');
            }
          }
        }
        // 如果输入框有值，但未从下拉列表选择（isSelected 为 false），清空输入框
        else if (inputValue && !this.isSelected) {
          // 清空输入框
          this.inputText.value = '';
          this.searchQuery = '';
          this.currentCountry = null;
          this.isSelected = false;
          this.updateDisplay();
          
          // 触发 onChange 事件（值为 null）
          if (this.hiddenInput) {
            this.hiddenInput.value = '';
            this.hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          
          // 显示错误提示
          this.container.classList.add('component-dialcode-selector--error');
          const errorElement = this.container.querySelector('.component-dialcode-selector__error');
          if (errorElement) {
            errorElement.textContent = this.messages.chooseOptionFromList;
            errorElement.style.display = 'block';
          }
        }
        
        // 如果输入框没有值且未选择，label回到居中位置（与国家选择器一致）
        if (label && !this.inputText.value && !this.isSelected) {
          label.classList.remove('is-float');
        }
      });
      
      // 处理回车键
      this.inputText.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          const inputValue = (this.inputText.value || '').trim();
          
          // 如果输入框有值，但未从下拉列表选择，清空输入框
          if (inputValue && !this.isSelected) {
            // 清空输入框
            this.inputText.value = '';
            this.searchQuery = '';
            this.currentCountry = null;
            this.isSelected = false;
            this.updateDisplay();
            
            // 触发 onChange 事件（值为 null）
            if (this.hiddenInput) {
              this.hiddenInput.value = '';
              this.hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
            
            // 显示错误提示
            this.container.classList.add('component-dialcode-selector--error');
            const errorElement = this.container.querySelector('.component-dialcode-selector__error');
            if (errorElement) {
              errorElement.textContent = this.messages.chooseOptionFromList;
              errorElement.style.display = 'block';
            }
            
            // 移开焦点
            this.inputText.blur();
          }
        }
      });
      this.inputText.addEventListener('input', (e) => {
        const raw = (e.target.value || '');
        const value = raw.trim();
        this.searchQuery = value;
        // 与国家选择器一致：用户输入只用于搜索，不立刻清空已选择的值；
        // 是否选择由下拉列表点击决定，失焦时会恢复选中值或提示错误。
        if (!this.isDropdownOpen) this.openDropdown();
        this.filterCountries();
      });
    }
    
    // 按钮点击事件（点击容器也可打开）
    this.stateLayer.addEventListener('click', (e) => {
      // 若点击的是输入框，交由输入框事件处理
      if (e.target === this.inputText) return;
      e.preventDefault();
      e.stopPropagation();

      // 已展开时直接收起，避免先 focus 输入框又被 focus 监听重新展开。
      if (this.isDropdownOpen) {
        this.closeDropdown();
        return;
      }

      // 未展开时，保持原有体验：优先让输入框获得焦点并触发展开。
      if (this.inputText && document.activeElement !== this.inputText) {
        this.inputText.focus();
      } else {
        this.openDropdown();
      }
    });
    
    // 点击外部关闭下拉菜单
    document.addEventListener('click', (e) => {
      if (!this.container.contains(e.target)) {
        this.closeDropdown();
      }
    });
  }
  
  // 模糊匹配
  fuzzyMatch(text, query) {
    if (!query) return true;
    const t = (text || '').toLowerCase();
    const q = query.toLowerCase();
    if (t.includes(q)) return true;
    let i = 0;
    for (let c of q) {
      const idx = t.indexOf(c, i);
      if (idx === -1) return false;
      i = idx + 1;
    }
    return true;
  }
  
  // 过滤国家列表
  filterCountries() {
    const q = (this.searchQuery || '').trim();
    if (!q) {
      this.renderCountryList(ALL_COUNTRIES, false);
      return;
    }
    const filtered = ALL_COUNTRIES.filter(code => {
      const dial = this.getCountryCallingCode(code);
      const name = this.getCountryName(code);
      const dialStr = String(dial).replace(/\+/g, '');
      const dialWithPlus = `+${dialStr}`;
      // 支持多种匹配方式：
      // 1. 匹配国家名称
      // 2. 匹配区号（不含+）
      // 3. 匹配区号（含+）
      // 4. 如果查询包含+，移除后匹配区号
      const qWithoutPlus = q.replace(/\+/g, '');
      
      // 支持多种匹配方式：
      // 1. 匹配国家名称（如 "Singapore"）
      // 2. 匹配区号数字（如 "65"）
      // 3. 匹配带 "+" 的区号（如 "+65"）
      // 4. 如果查询包含 "+"，移除后匹配区号（如用户输入 "+65" 匹配 "65"）
      // 注意：如果查询只有 "+"，qWithoutPlus 为空，不会匹配所有内容
      return this.fuzzyMatch(name, q) 
        || this.fuzzyMatch(dialStr, q) 
        || this.fuzzyMatch(dialWithPlus, q)
        || (qWithoutPlus && this.fuzzyMatch(dialStr, qWithoutPlus));
    });
    // 搜索时传入 isSearching = true，不区分热门
    this.renderCountryList(filtered, true);
  }
  
  toggleDropdown() {
    if (this.isDropdownOpen) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }
  
  openDropdown() {
    ensureDropdownCoordinator().closeOthers(this.container);
    this.isDropdownOpen = true;
    this.dropdown.style.display = 'block';
    this.stateLayer.setAttribute('aria-expanded', 'true');
    this.container.setAttribute('aria-expanded', 'true');
    
    // 确保 label 在展开时始终可见（与国家选择器一致）
    const label = this.container.querySelector('.component-dialcode-selector__label');
    if (label) {
      label.classList.add('is-float');
    }
    
    // 重新渲染列表，确保选中状态正确显示
    const hasQuery = !!(this.searchQuery && this.searchQuery.trim());
    if (hasQuery) {
      this.filterCountries();
    } else {
      this.renderCountryList(ALL_COUNTRIES, false);
    }
    
    // 手机端：让下拉菜单与 setup-phone-page__input-group 同宽
    if (window.innerWidth <= 734) {
      const inputGroup = this.container.closest('.setup-phone-page__input-group');
      if (inputGroup) {
        const inputGroupWidth = inputGroup.offsetWidth;
        this.dropdown.style.width = inputGroupWidth + 'px';
        // 计算选择器左边缘到 input-group 左边缘的距离
        const selectorRect = this.container.getBoundingClientRect();
        const inputGroupRect = inputGroup.getBoundingClientRect();
        const offsetLeft = selectorRect.left - inputGroupRect.left;
        this.dropdown.style.left = -offsetLeft + 'px';
      }
    }
  }
  
  closeDropdown() {
    this.isDropdownOpen = false;
    this.dropdown.style.display = 'none';
    this.stateLayer.setAttribute('aria-expanded', 'false');
    this.container.setAttribute('aria-expanded', 'false');
    
    // 重置下拉菜单的宽度和位置（如果之前设置了）
    if (window.innerWidth <= 734) {
      this.dropdown.style.width = '';
      this.dropdown.style.left = '';
    }
  }
  

  
  renderCountryList(countries = ALL_COUNTRIES, isSearching = false) {
    if (!this.list) return;
    const messages = getDialcodeSelectorMessages();
    
    this.list.innerHTML = '';
    
    // 渲染函数
    const renderItem = (countryCode) => {
      const item = document.createElement('button');
      item.className = 'component-dialcode-selector__item';
      item.type = 'button';
      // 只有当已选择国家且匹配时才添加选中样式
      if (this.isSelected && countryCode === this.currentCountry) {
        item.classList.add('component-dialcode-selector__item--selected');
      }
      
      const dialCode = this.getCountryCallingCode(countryCode);
      const flag = this.getCountryFlag(countryCode);
      const name = this.getCountryName(countryCode);
      
      item.innerHTML = `
        <span class="component-dialcode-selector__item-code">+${dialCode}</span>
        <span class="component-dialcode-selector__item-name">${name}</span>
      `;
      
      // Prevent the searchable input from blurring before the option click runs.
      // Otherwise blur validation briefly shows "choose from list" while selecting.
      item.addEventListener('mousedown', (event) => {
        event.preventDefault();
      });

      item.addEventListener('click', () => {
        this.selectCountry(countryCode);
      });
      
      return item;
    };
    
    // 如果是搜索状态，直接显示所有匹配结果，不区分热门
    if (isSearching) {
      if (countries.length === 0) {
        // 没有匹配结果时显示提示
        const noMatchItem = document.createElement('div');
        noMatchItem.className = 'component-dialcode-selector__item component-dialcode-selector__item--no-match';
        noMatchItem.style.pointerEvents = 'none';
        noMatchItem.style.cursor = 'default';
        const noMatchSpan = document.createElement('span');
        noMatchSpan.textContent = messages.noMatchingResults;
        noMatchItem.appendChild(noMatchSpan);
        this.list.appendChild(noMatchItem);
      } else {
        // 按名称排序（A-Z）
        const sortedCountries = countries.sort((a, b) => {
          const nameA = this.getCountryName(a).toLowerCase();
          const nameB = this.getCountryName(b).toLowerCase();
          return nameA.localeCompare(nameB);
        });
        
        sortedCountries.forEach(countryCode => {
          this.list.appendChild(renderItem(countryCode));
        });
      }
      return;
    }
    
    // 非搜索状态：区分热门国家和其他国家
    // 热门国家代码列表（从 COUNTRIES_HOT_DATA 获取）
    const hotCountryCodes = [];
    if (window.COUNTRIES_HOT_DATA && Array.isArray(window.COUNTRIES_HOT_DATA)) {
      hotCountryCodes.push(...window.COUNTRIES_HOT_DATA.map(country => country.short_upper));
    }
    // 如果没有 COUNTRIES_HOT_DATA，使用默认热门国家
    if (hotCountryCodes.length === 0) {
      hotCountryCodes.push('SG', 'US', 'CA', 'NL', 'GB', 'DE', 'AU');
    }
    const hotCountrySet = new Set(hotCountryCodes);
    
    // 分离热门国家和其他国家
    const hotCountries = [];
    const otherCountries = [];
    
    countries.forEach(countryCode => {
      if (hotCountrySet.has(countryCode)) {
        hotCountries.push(countryCode);
      } else {
        otherCountries.push(countryCode);
      }
    });
    
    // 热门国家按预定义顺序排序
    const sortedHotCountries = hotCountries.sort((a, b) => {
      const indexA = hotCountryCodes.indexOf(a);
      const indexB = hotCountryCodes.indexOf(b);
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;
      return indexA - indexB;
    });
    
    // 其他国家按名称排序
    const sortedOtherCountries = otherCountries.sort((a, b) => {
      const nameA = this.getCountryName(a).toLowerCase();
      const nameB = this.getCountryName(b).toLowerCase();
      return nameA.localeCompare(nameB);
    });
    
    // 先渲染热门国家
    sortedHotCountries.forEach(countryCode => {
      this.list.appendChild(renderItem(countryCode));
    });
    
    // 如果有热门国家和其他国家，添加分隔线
    if (sortedHotCountries.length > 0 && sortedOtherCountries.length > 0) {
      const separator = document.createElement('div');
      separator.className = 'component-dialcode-selector__separator';
      separator.textContent = messages.moreOptionsBelow;
      this.list.appendChild(separator);
    }
    
    // 渲染其他国家（已剔除热门国家）
    sortedOtherCountries.forEach(countryCode => {
      this.list.appendChild(renderItem(countryCode));
    });
  }
  
  selectCountry(countryCode) {
    this.currentCountry = countryCode;
    this.isSelected = true; // 标记已选择国家
    this.updateDisplay();
    this.closeDropdown();
    
    // 清除错误状态
    this.container.classList.remove('component-dialcode-selector--error');
    const errorElement = this.container.querySelector('.component-dialcode-selector__error');
    if (errorElement) {
      errorElement.style.display = 'none';
    }
    
    // 触发自定义事件
    this.container.dispatchEvent(new CustomEvent('countryChanged', {
      detail: { 
        countryCode,
        dialCode: this.getCountryCallingCode(countryCode)
      }
    }));
  }
  
  updateDisplay() {
    const label = this.container.querySelector('.component-dialcode-selector__label');
    
    if (this.inputText) {
      if (this.isSelected) {
        // 已选择国家，显示区号
        const dialCode = this.getCountryCallingCode(this.currentCountry);
        if (this.inputText.tagName === 'INPUT') {
          this.inputText.value = `+${dialCode}`;
        } else {
          this.inputText.textContent = `+${dialCode}`;
        }
        this.inputText.setAttribute('data-country', this.currentCountry);
        // 添加 has-value 类来触发标签浮动
        if (label) {
          label.classList.add('is-float');
        }
        this.container.classList.add('component-dialcode-selector--has-value');
      } else {
        // 未选择国家，清空内容
        if (this.inputText.tagName === 'INPUT') {
          this.inputText.value = '';
        } else {
          this.inputText.textContent = '';
        }
        this.inputText.removeAttribute('data-country');
        // 移除 has-value 类，标签回到居中位置
        if (label) {
          label.classList.remove('is-float');
        }
        this.container.classList.remove('component-dialcode-selector--has-value');
      }
    }
    
    if (this.hiddenInput) {
      if (this.isSelected) {
        // 已选择国家，设置区号值
        const dialCode = this.getCountryCallingCode(this.currentCountry);
        this.hiddenInput.value = `+${dialCode}`;
        this.hiddenInput.setAttribute('data-country', this.currentCountry);
      } else {
        // 未选择国家，清空值
        this.hiddenInput.value = '';
        this.hiddenInput.removeAttribute('data-country');
      }
    }
  }
  
  // 使用 libphonenumber-js 库获取区号
  getCountryCallingCode(countryCode) {
    if (typeof libphonenumber !== 'undefined') {
      try {
        const dialCode = libphonenumber.getCountryCallingCode(countryCode);
        if (dialCode && dialCode.length > 0) {
          return dialCode;
        }
      } catch (error) {
        // 静默处理错误
      }
    }
    
    console.warn('libphonenumber-js 未提供区号或未加载，countryCode =', countryCode);
    return '';
  }
  
  // 获取国家国旗 emoji
  getCountryFlag(countryCode) {
    const codePoints = countryCode
      .toUpperCase()
      .split('')
      .map(char => 127397 + char.charCodeAt());
    return String.fromCodePoint(...codePoints);
  }
  
  // 获取国家名称
  getCountryName(countryCode) {
    return getCountryNameHelper(countryCode);
  }
  
  // 公共方法
  getValue() {
    return {
      countryCode: this.currentCountry,
      dialCode: this.getCountryCallingCode(this.currentCountry),
      fullDialCode: `+${this.getCountryCallingCode(this.currentCountry)}`
    };
  }
  
  // 验证手机号格式
  validatePhoneNumber(phoneNumber) {
    const rawPhoneNumber = String(phoneNumber || '');
    const dialCode = this.getCountryCallingCode(this.currentCountry);


    if (typeof libphonenumber !== 'undefined') {
      try {
        const fullNumber = `+${dialCode}${rawPhoneNumber}`;
        const parsedNumber = libphonenumber.parsePhoneNumber(fullNumber);
        const nationalNumber = String(parsedNumber.nationalNumber || '');
        const parsedIsValid = parsedNumber.isValid();
        const isValid = parsedIsValid;
        const numberType = parsedNumber.getType();
        const formattedNumber = parsedNumber.format('INTERNATIONAL');
        const parsedCountryCode = String(parsedNumber.countryCallingCode || '');
  
        return {
          isValid: isValid,
          numberType: numberType,
          formattedNumber: formattedNumber,
          nationalNumber: nationalNumber
        };
      } catch (error) {
        return {
          isValid: false,
          error: error.message
        };
      }
    }
    
    // 备用验证逻辑
    // 首先检查原始输入是否包含非数字字符
    if (/\D/.test(phoneNumber)) {
      return {
        isValid: false,
        numberType: 'UNKNOWN',
        formattedNumber: rawPhoneNumber,
        nationalNumber: rawPhoneNumber
      };
    }
    
    const minLength = 7;
    const maxLength = 15;
    const isValid = rawPhoneNumber.length >= minLength && rawPhoneNumber.length <= maxLength;
    
    return {
      isValid: isValid,
      numberType: 'UNKNOWN',
      formattedNumber: rawPhoneNumber,
      nationalNumber: rawPhoneNumber
    };
  }
  
  // 格式化手机号
  formatPhoneNumber(phoneNumber) {
    const rawPhoneNumber = String(phoneNumber || '');
    const digitsOnlyPhoneNumber = rawPhoneNumber.replace(/\D/g, '');

    if (typeof libphonenumber !== 'undefined') {
      try {
        const fullNumber = `+${this.getCountryCallingCode(this.currentCountry)}${rawPhoneNumber}`;
        const parsedNumber = libphonenumber.parsePhoneNumber(fullNumber);
        return String(parsedNumber.nationalNumber || '').replace(/\D/g, '') || digitsOnlyPhoneNumber;
      } catch (error) {
        return digitsOnlyPhoneNumber;
      }
    }
    return digitsOnlyPhoneNumber;
  }
  
  setValue(countryCode) {
    const normalizedCountry = String(countryCode || '').trim().toUpperCase();
    if (!normalizedCountry) return;

    const isKnownCountry = ALL_COUNTRIES.includes(normalizedCountry);
    const dialCode = this.getCountryCallingCode(normalizedCountry);

    if (isKnownCountry || dialCode) {
      this.currentCountry = normalizedCountry;
      this.isSelected = true; // 标记已选择国家
      this.updateDisplay();
    }
  }
}

// 全局初始化函数
function initDialCodeSelectors() {
  // 测试库是否正确工作
  window.DialCodeSelector.testLibrary();
  
  // 确保国家数据已初始化
  if (ALL_COUNTRIES.length === 0) {
    initializeCountries();
  }
  
  const selectors = document.querySelectorAll('[data-component="dialcode-selector"]');
  
  selectors.forEach((container, index) => {
    if (!container.dialCodeSelector) {
      container.dialCodeSelector = new DialCodeSelector(container);
    }
  });
}



// 全局组件管理器
window.DialCodeSelector = {
  init: initDialCodeSelectors,
  
  getInstance(container) {
    return container.dialCodeSelector;
  },
  
  getValue(container) {
    const instance = this.getInstance(container);
    return instance ? instance.getValue() : null;
  },
  
  setValue(container, countryCode) {
    if (!container) return;

    let instance = this.getInstance(container);
    if (!instance && container.matches && container.matches('[data-component="dialcode-selector"]')) {
      instance = new DialCodeSelector(container);
      container.dialCodeSelector = instance;
    }

    if (instance) {
      instance.setValue(countryCode);
    }
  },
  
  // 验证手机号格式
  validatePhoneNumber(container, phoneNumber) {
    const instance = this.getInstance(container);
    return instance ? instance.validatePhoneNumber(phoneNumber) : null;
  },
  
  // 格式化手机号
  formatPhoneNumber(container, phoneNumber) {
    const instance = this.getInstance(container);
    return instance ? instance.formatPhoneNumber(phoneNumber) : null;
  },
  
      // 测试函数 - 验证库是否正确工作
    testLibrary() {
      if (typeof libphonenumber !== 'undefined') {
        try {
          const countries = libphonenumber.getCountries();
          return countries && countries.length > 0;
        } catch (error) {
          return false;
        }
      } else {
        return false;
      }
    }
};

// DOM加载完成后初始化
document.addEventListener('DOMContentLoaded', function() {
  // 等待 libphonenumber-js 库加载完成
  if (typeof libphonenumber !== 'undefined') {
    initDialCodeSelectors();
  } else {
    // 如果库还没加载，等待一段时间后重试
    setTimeout(() => {
      if (typeof libphonenumber !== 'undefined') {
        initDialCodeSelectors();
      } else {
        // 如果库仍然未加载，使用备用数据初始化
        initDialCodeSelectors();
      }
    }, 1000);
  }
});

// 监听库加载完成事件
window.addEventListener('load', function() {
  if (typeof libphonenumber !== 'undefined' && ALL_COUNTRIES.length === 0) {
    initializeCountries();
    // 重新初始化所有组件
    const selectors = document.querySelectorAll('[data-component="dialcode-selector"]');
    selectors.forEach(container => {
      if (container.dialCodeSelector) {
        // 重新渲染国家列表
        container.dialCodeSelector.renderCountryList();
      }
    });
  }
}); 
